import "./AboutUs.css";
import { Helmet } from "react-helmet-async";

export const AboutUsPage = () => {
  return (
    <>
      <Helmet>
        <title>
          About Yuva Quest | Connect with Indian Culture and Heritage
        </title>
        <link rel="canonical" href="https://yuvaquest.com/about" />
        <meta
          name="description"
          content="Interactive quests for kids to explore Indian history, heroes, and gods. Learn, play, and connect with Indian roots!"
        />
      </Helmet>
      <div className="webUi my_custom_section ">
        <h2 className="webUi">About Us</h2>
      </div>

      <div className="formdiv container  ">
        <p className="webUi">
          We are your bridge to the captivating world of Indian culture and
          history. We believe that the best way to impart knowledge is through
          entertainment, for anything that is learned through curiosity and is
          fun, sparked by imagination, results in a lifetime and never-to-forget
          imprint on children’s minds. We are an edutainment brand for children
          where Entertainment meets Education. India has a vast cultural
          tapestry and Yuva Quest believes that learning about one’s heritage
          should be an enthralling journey, not just another school subject.
          Thus we combine the power of storytelling, and the depth of
          educational content into a platform that brings the legends of India
          to life. We Invite you to be a part of the Yuva Quest community.
        </p>
        <p className="webUi">
          Whether you’re a parent, educator, or a young explorer. There’s
          something here for everyone. Join us on the Journey and Dive into our
          quests, explore the stories, and gather the wisdom of India’s past,
          its rich heritage, culture, history and mythologies. Our interactive
          problem solving quests introduce children to ancient characters,
          historical heroes, as well as medieval history and so on. Each of our
          content is carefully curated in a manner to appeal to children and
          impart positive messages to them. Incorporating a variety of fun
          activities through the method of teaching can captivate children’s
          interests and thus we thrive to create effective and easy methods to
          impart early childhood education through our Quests and creative
          problem-solving methods.
        </p>
        <p className="webUi">
          We even have mascots that resemble children and motivate them to
          explore further. In the enthusiasm of receiving virtual rewards and in
          order to unlock new levels ahead, children get motivated in solving
          the quests and quizzes. This helps them in critical thinking, improves
          concentration and develops determination and focus. Listening to the
          dialogues also help children develop confidence and communication
          skills aiding in social interactions. Join us in our Quests and
          Explore the world like never before! We believe in curiosity driven
          learning. That is why we go by the moto:
        </p>
        <blockquote>
          <p>Every lesson is a quest and every quest is a lesson.</p>
        </blockquote>
        <p>
          Where every quest is a lesson, and every lesson is a quest. Our
          platform transforms education into playful activities, captivating
          young minds with interactive fun.
        </p>
      </div>
    </>
  );
};
